"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const errors_1 = require("../errors");
const getReportsApiDefinition_1 = require("./getReportsApiDefinition");
const getEndpointUrl = (request) => {
    const apiDefinition = (0, getReportsApiDefinition_1.default)(request.config);
    if (apiDefinition) {
        const searchParams = (0, lodash_1.merge)({}, apiDefinition === null || apiDefinition === void 0 ? void 0 : apiDefinition.query, request === null || request === void 0 ? void 0 : request.query);
        const hasQueryParams = Boolean(Object.keys(searchParams).length);
        if (hasQueryParams) {
            const qs = new URLSearchParams(searchParams).toString();
            return `${apiDefinition.url}${request.path}?${qs}`;
        }
        return `${apiDefinition.url}${request.path}`;
    }
    throw new errors_1.InvalidRequestConfigError();
};
exports.default = getEndpointUrl;
